import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Row, MultiLineInput } from "app/NativeComponents/common";

import BottomButtons from "./BottomButtons";
import SelectFromNumber from "./SelectFromNumber";
import Responses from "./Responses";
import BracketHelper from "./BracketHelper";

import { getSavedResponses, updateSavedResponse } from "app/NativeActions";

class MessageTextBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      message: props.messageValue ? props.messageValue : "",
      message_height: 0,

      mention_tracker: false,
      mention_keyword: "",
      mention_prev_char: " ",

      show_save_reply: false,

      selected_from_number: props.selected_from_number,
      show_brackets: false
    };

    this.updateMessageProp = this.updateMessageProp.bind(this);
    this.updateSelectedFromPhoneNumber = this.updateSelectedFromPhoneNumber.bind(
      this
    );
  }

  getResponses(search = "") {
    if (!this.props.saved_responses_loading) {
      this.props.getSavedResponses({
        token: this.props.token,
        response_type:
          this.props.selected_conversations &&
          this.props.selected_conversations.length > 0 &&
          this.props.selected_conversations[0].received_response
            ? "no_conversation_starters"
            : "conversation_starters",
        search: search
      });
    }
  }

  componentDidMount() {
    this.getResponses();

    if (
      this.props.team_phone_number_groups &&
      this.props.team_phone_number_groups.length == 0
    ) {
      this.props.getTeamPhoneNumbers({
        token: this.props.token
      });
    }
  }

  updateSelectedFromPhoneNumber(selected_from_number) {
    this.setState({
      selected_from_number: selected_from_number
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.messageValue !== this.props.messageValue) {
      this.setState({
        message: this.props.messageValue
      });
    } else if (
      prevState.message != this.state.message &&
      this.props.onMessageChange
    ) {
      this.props.onMessageChange(this.state.message);
    }

    if (
      !prevState.message &&
      prevState.message != "" &&
      this.state.message == ""
    ) {
      this.resetTextbox();
    }

    if (prevProps.selected_from_number !== this.props.selected_from_number) {
      this.setState({
        selected_from_number: this.props.selected_from_number
      });
    }

    if (
      prevProps.selected_conversations != this.props.selected_conversations &&
      this.props.selected_conversations &&
      this.props.selected_conversations.length == 0
    ) {
      this.props.toggleTab("message");
    }
  }

  componentWillUnmount() {
    clearInterval(this._mention_interval);
  }

  updateMessageProp({ prop, value }) {
    this.setState({ [prop]: value });
  }

  updateSuggestions(lastKeyword) {
    this.updateMessageProp({ prop: "mention_keyword", value: lastKeyword });
    clearInterval(this._mention_interval);
    this._mention_interval = setTimeout(() => {
      const username_search = lastKeyword.replace("#", "");
      this.getResponses(username_search);
    }, 250);
  }

  identifyKeyword(val) {
    if (this.state.mention_tracker) {
      const boundary = "B";
      const trigger = "#";
      const pattern = new RegExp(
        `\\${boundary}${trigger}[a-z0-9_-]+|\\${boundary}${trigger}`,
        `gi`
      );
      const keywordArray = val.match(pattern);
      if (keywordArray && !!keywordArray.length) {
        const lastKeyword = keywordArray[keywordArray.length - 1];
        this.updateSuggestions(lastKeyword);
      }
    }
  }

  onChange(event) {
    let value = "";
    if (this.props.device == "desktop") {
      value = event;
    } else {
      value = event.nativeEvent.text;
    }
    this.updateMessageProp({ prop: "message", value });

    const lastChar = value.substr(value.length - 1);
    const wordBoundry = this.state.mention_prev_char.trim().length == 0;
    if (lastChar == "#" && wordBoundry) {
      this.updateMessageProp({ prop: "mention_tracker", value: true });
      this.updateMessageProp({ prop: "mention_keyword", value: lastChar });
      this.updateMessageProp({ prop: "show_save_reply", value: false });
      this.getResponses();
    } else if (
      ((lastChar == " " || lastChar == "\n") && this.state.mention_tracker) ||
      value == ""
    ) {
      this.updateMessageProp({ prop: "mention_tracker", value: false });
      this.updateMessageProp({ prop: "show_save_reply", value: true });
    } else {
      this.updateMessageProp({ prop: "show_save_reply", value: true });
    }
    this.updateMessageProp({ prop: "mention_prev_char", value: lastChar });

    this.identifyKeyword(value);
  }

  resetTextbox() {
    this.updateMessageProp({ prop: "mention_prev_char", value: " " });
    this.updateMessageProp({ prop: "mention_tracker", value: false });
    this.updateMessageProp({ prop: "mention_keyword", value: "" });
  }

  renderMessageHeader() {
    if (this.props.renderMessageHeader) {
      return this.props.renderMessageHeader();
    }
  }

  renderBrackets() {
    if (this.state.show_brackets) {
      return (
        <BracketHelper
          updateMessageProp={this.updateMessageProp}
          message={this.state.message}
          colors={this.props.colors}
        />
      );
    }
  }

  render() {
    if (this.props.tab == "message") {
      return (
        <Wrapper>
          {!this.props.keyboard_showing ? (
            <SelectFromNumber
              {...this.props}
              selected_from_number={this.state.selected_from_number}
              updateSelectedFromPhoneNumber={this.updateSelectedFromPhoneNumber}
              onFromNumberChange={this.props.onFromNumberChange}
            />
          ) : null}
          <Responses
            updateMessageProp={this.updateMessageProp}
            mention_tracker={this.state.mention_tracker}
            mention_keyword={this.state.mention_keyword}
            mention_prev_char={this.state.mention_prev_char}
            message={this.state.message}
            saved_responses={this.props.saved_responses}
            saved_responses_loading={this.props.saved_responses_loading}
            user={this.props.user}
            colors={this.props.colors}
            {...this.props}
          />

          {this.renderBrackets()}

          <Row
            style={{
              padding: 15,
              paddingTop: 10,
              paddingBottom: 10
            }}
          >
            <MultiLineInput
              name={"message"}
              no_container
              placeholder={
                "Type # to add a saved reply or type your message here."
              }
              label={"Enter your message here."}
              style={[
                {
                  flex: 1,
                  fontSize: 14,
                  maxHeight: 120,
                  marginRight: 0,
                  marginLeft: 0
                },
                {
                  height:
                    Math.max(35, this.state.message_height) > 105
                      ? 105
                      : Math.max(35, this.state.message_height)
                }
              ]}
              value={this.state.message}
              onChange={event => {
                this.onChange(event);
              }}
              all_changes={true}
              onContentSizeChange={event => {
                this.updateMessageProp({
                  prop: "message_height",
                  value: event.nativeEvent.contentSize.height
                });
              }}
              spellCheck={true}
              autoCorrect={true}
            />
          </Row>
          <BottomButtons
            token={this.props.token}
            updateMessageProp={this.updateMessageProp}
            mention_tracker={this.state.mention_tracker}
            show_brackets={this.state.show_brackets}
            message={this.state.message}
            onSubmit={this.props.onSubmit}
            selected_from_number={this.state.selected_from_number}
            colors={this.props.colors}
            disabled={this.props.disabled}
            show_save_reply={this.state.show_save_reply}
            appRedirect={this.props.appRedirect}
            updateSavedResponse={this.props.updateSavedResponse}
            saved_responses={this.props.saved_responses}
            saved_responses_loading={this.props.saved_responses_loading}
            setEditModal={this.props.setEditModal}
          />
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({ auth, message, native }) => {
  const { token, user } = auth;

  const { saved_responses, saved_responses_loading } = message;
  const { keyboard_showing } = native;

  return {
    token,
    user,
    saved_responses,
    saved_responses_loading,
    keyboard_showing
  };
};

export default connect(mapStateToProps, {
  getSavedResponses,
  updateSavedResponse
})(MessageTextBox);
